import React from "react";
import { useAppContext } from "../../AppProvider";
import { useTypes } from "../../utilities/types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import InputBoxIcon from "../../Components/Inputs/InputIcon/InputIcon";
import { CustomData } from "../../Models/CustomData";
import {
  faBarcode,
  faLocationDot,
  faQ,
  faWeightHanging,
} from "../../utilities/fontawesomeIcons";
import { getCustomDatasListItemGridLayout } from "./Layout";
import { createcustomDatasListItemrGridVars } from "./Layout/gridVars";

export const CustomDataListItem: React.FC<{
  listRef: React.RefObject<{
    refresh: () => void;
  } | null>;
  item: CustomData;
  index: number;
}> = React.memo(({ item }) => {
  const { dictionary, display } = useAppContext();
  const { countryIsoCodes2, customData, currencies2 } = useTypes();

  const countries = {
    countryIsoCodes2: countryIsoCodes2.find(
      (c) => c.code === item.countryIsoCode2,
    ),
  };
  const icons = {
    categoryCode: customData.find((c) => c.value === item.categoryCode),
    currencies: currencies2.find((c) => c.value === item.unitPriceCurrencyCode),
  };

  const customDatasListItemLayout = getCustomDatasListItemGridLayout(display);
  const customDatasListItemStyle = createcustomDatasListItemrGridVars(
    customDatasListItemLayout,
  );

  return (
    <>
      <div
        data-grid-template="customDatasListItem"
        className="d-grid gap-2 p-2 rounded-2 align-items-center"
        style={customDatasListItemStyle}
      >
        <div data-grid-area="icon" className="d-flex justify-content-center">
          <div
            className="d-flex justify-content-center align-items-center p-3"
            title={icons.categoryCode?.label}
            style={{
              width: "auto",
              height: "auto",
              borderRadius: "50%",
              backgroundColor: "#f5f5f5",
              margin: display.xs ? "0.5rem 0 0" : 0,
            }}
          >
            <FontAwesomeIcon
              icon={icons?.categoryCode?.icon}
              title={icons.categoryCode?.label}
            />
          </div>
        </div>
        <div data-grid-area="description">
          {(display.xs || display.sm || display.md) && (
            <label className="label-2">
              {dictionary.registries.description}
            </label>
          )}
          <InputBoxIcon
            name="description"
            value={item.description || "-"}
            type="text"
            disabled
          />
        </div>
        <div data-grid-area="unitWeight">
          {(display.xs || display.sm || display.md) && (
            <label className="label-2">
              {dictionary.dimensions.unit_weight}:
            </label>
          )}
          <InputBoxIcon
            name="unitWeight"
            value={item?.unitWeight || "-"}
            type="positive-number"
            placeholder="10"
            icon={faWeightHanging}
            disabled
          />
        </div>

        <div data-grid-area="unitPrice">
          {(display.xs || display.sm || display.md) && (
            <label className="label-2">
              {dictionary.dimensions.unit_value}
            </label>
          )}
          <InputBoxIcon
            name="unitPrice"
            value={item?.unitPrice || "-"}
            type="positive-number"
            icon={icons.currencies?.icon}
            disabled
          />
        </div>
        <div data-grid-area="hsCode">
          {(display.xs || display.sm || display.md) && (
            <label className="label-2">{dictionary.customs_data.hs_code}</label>
          )}
          <InputBoxIcon
            name="hsCode"
            value={item?.hsCode || "-"}
            type="text"
            icon={faBarcode}
            disabled
          />
        </div>
        <div data-grid-area="countryIsoCode2">
          {(display.xs || display.sm || display.md) && (
            <label className="label-2">
              {dictionary.customs_data.country_of_origin}
            </label>
          )}
          <InputBoxIcon
            name="countryIsoCode2"
            value={countries.countryIsoCodes2?.label || "-"}
            type="text"
            icon={faLocationDot}
            disabled
          />
        </div>
        <div data-grid-area="quantity">
          {(display.xs || display.sm || display.md) && (
            <label className="label-2">{dictionary.registries.quantity}</label>
          )}
          <InputBoxIcon
            name="quantity"
            value={item?.quantity || "-"}
            type="positive-integer-number"
            placeholder="1"
            icon={faQ}
            disabled
          />
        </div>
      </div>
    </>
  );
});
